import React from "react"
import css from "@styled-system/css"
import { useTheme } from "emotion-theming"

import { Container, Col, Row } from "@bigif/components/grid"
import Button from "@bigif/components/button"
import Card from "@bigif/components/card"
import { Medium, Heading } from "@bigif/components/typography"
import Gradient from "@bigif/components/gradient"

const Stats = () => {
  const theme = useTheme()
  const handleClick = e => {
    e.preventDefault()
    const { href } = e.currentTarget
    if (typeof window != undefined) {
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-837012328/OjW_CKO24NkCEOiWj48D",
          event_callback: () => {
            if (href) {
              window.location = href
            }
          },
        })
      }

      return false
    }
  }
  return (
    <Gradient
      css={css({ pt: [6, 7] })}
      color={theme.colors.secondary}
      position="center"
    >
      <Container>
        <Heading as="h1" textAlign="center" fontSize={[4, 5]}>
          Statistiques et ressources
        </Heading>
        <Row>
          <Col width={[1, 1 / 2]}>
            <Card variant="secondary" align="center">
              <Heading fontSize={[2, 3]} textAlign="center">
                Centre Intact sur l'adaptation au climat
              </Heading>
              <Medium>
                Le Centre Intact d'adaptation au climat propose des tonnes de
                ressources pour se préparer aux inondations.
              </Medium>
              <Button
                as="a"
                onClick={handleClick}
                href="https://www.intactcentre.ca/programs/home_flood_protect/"
                variant="secondary"
              >
                Voir les ressources
              </Button>
            </Card>
          </Col>
          <Col width={[1, 1 / 2]}>
            <Card variant="secondary" align="center">
              <Heading fontSize={[2, 3]} textAlign="center">
                Cartographie des risques sismiques
              </Heading>
              <Medium>
                Les ICLR offrent un outil de cartographie des risques sismiques
                et plus encore.
              </Medium>
              <Button
                as="a"
                onClick={handleClick}
                href="https://www.iclr.org/earthquake-risk/"
                variant="secondary"
              >
                Utiliser l’outil
              </Button>
            </Card>
          </Col>
          <Col width={[1, 1 / 2]}>
            <Card variant="secondary" align="center">
              <Heading fontSize={[2, 3]} textAlign="center">
                Inondations au Canada
              </Heading>
              <Medium>
                Lire au sujet des inondations au Canada, un document signé
                Partners for Action.
              </Medium>
              <Button
                as="a"
                onClick={handleClick}
                href="https://uwaterloo.ca/partners-for-action/"
                variant="secondary"
              >
                Inondations au Canada
              </Button>
            </Card>
          </Col>
          <Col width={[1, 1 / 2]}>
            <Card variant="secondary" align="center">
              <Heading fontSize={[2, 3]} textAlign="center">
                Séismes au Canada
              </Heading>
              <Medium>
                Ressources naturelles Canada tient à jour un dossier détaillé
                des séismes au Canada.
              </Medium>
              <Button
                as="a"
                onClick={handleClick}
                href="http://earthquakescanada.nrcan.gc.ca/index-en.php"
                variant="secondary"
              >
                Séismes au Canada
              </Button>
            </Card>
          </Col>
          <Col width={[1, 1 / 2]}>
            <Card variant="secondary" align="center">
              <Heading fontSize={[2, 3]} textAlign="center">
                Trousses d’urgenc
              </Heading>
              <Medium>
                La Croix-Rouge canadienne couvre tous vos besoins en matière de
                trousse d'urgence.
              </Medium>
              <Button
                as="a"
                onClick={handleClick}
                href="https://www.redcross.ca/how-we-help/emergencies-and-disasters-in-canada/be-ready-emergency-preparedness-and-recovery/get-an-emergency-kit"
                variant="secondary"
              >
                Obtenir une trousse d'urgence
              </Button>
            </Card>
          </Col>
          <Col width={[1, 1 / 2]}>
            <Card variant="secondary" align="center">
              <Heading fontSize={[2, 3]} textAlign="center">
                Causes des inondations, coûts et occurrences
              </Heading>
              <Medium>
                Le Gouvernement du Canada a rassemblé des ressources sur les
                causes, les coûts et la survenance d'inondations.
              </Medium>
              <Button
                as="a"
                onClick={handleClick}
                href="http://earthquakescanada.nrcan.gc.ca/index-en.php"
                variant="secondary"
              >
                Causes d'inondation
              </Button>
            </Card>
          </Col>
        </Row>
        <Medium
          css={css({
            textAlign: "center",
            mt: 6,
          })}
        >
          Association des courtiers d’assurances du Canada
          <br />
          Exchange Tower
          <br />
          130, rue King Ouest, bureau 2125, Boîte postale 443
          <br />
          Toronto ON M5X 1E4
        </Medium>
        <Medium
          css={css({
            textAlign: "center",
            mt: 6,
          })}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="65"
            height="82"
            fill="none"
            viewBox="0 0 65 82"
            css={css({
              display: "block",
              mx: "auto",
              mb: 4,
            })}
          >
            <path
              fill="#F8F9FA"
              d="M64.296 40.97l-2.074 25.193c-.531 6.518-10.274 5.621-9.744-.785l1.608-19.62-6.608.368a24.851 24.851 0 012.54 10.971c0 6.599-2.588 12.605-6.8 17.057l-6.32-6.294c9.31-10.202 2.107-26.779-11.897-26.779a16.051 16.051 0 00-10.804 4.164l-6.319-6.294a24.976 24.976 0 0113.088-6.438l12.106-13.726-6.849-3.972-8.296 7.367c-4.824 4.293-11.351-2.963-6.512-7.271l10.933-9.722a4.889 4.889 0 015.708-.576S50.453 17.57 50.485 17.602c2.604 1.617 3.328 5.765.98 8.424l-9.389 10.65 17.059-.944c2.974-.176 5.402 2.306 5.16 5.237zM53.86 16.303c4.518 0 8.184-3.651 8.184-8.152 0-4.5-3.666-8.152-8.184-8.152s-8.184 3.652-8.184 8.152c0 4.5 3.666 8.152 8.184 8.152zm-28.844 56.81c-12.959 0-20.483-14.511-13.296-25.002l-6.383-6.358A24.579 24.579 0 000 57.081c0 20.933 24.23 32.257 40.42 19.62l-6.383-6.358a16.008 16.008 0 01-9.02 2.77z"
            ></path>
          </svg>
          WCAG 2.1 Level AA Compliant
          <br />
          &copy;2019, Insurance Brokers of Canada
        </Medium>
      </Container>
    </Gradient>
  )
}

export default Stats
